import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_7: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-7" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/01000000-c0a8-0242-40ae-08db4b1bd850_w1920_r4.jpg'
          }
        />
        <h2>
          <span>7</span>
          Бахмут. Наступ Росії
          <strong>{texts.menu_14}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          У цей період основна увага ЗСУ була прикута до оборони Бахмута, хоча в
          цілому Росія продовжувала свій тиск на різних ділянках фронту.
          Бахмутська оборонна операція була дуже затратною для Кремля: за
          висновками Британської розвідки, у Бахмуті Росія втрачала по одному
          солдату за кожні 48 сантиметрів території. Проте, українські війська
          планомірно витіснялися як з самого міста, так і з його флангів.
          Головним підрозділом Росії у штурмі Бахмута була ПВК Вагнера: це під
          час бахмутських боїв її лідер Євген Пригожин сказав свою відому фразу:
          «Шойгу, Герасимов, де с..ка боєприпаси?!» Чимало військових аналітиків
          вважають битву за Бахмут надто виснажливою і кровопролитною для
          України. Проте, її сенсом на той момент називали «перемелювання»
          російських військ, які в іншому разі могли бути задіяні в інших
          операціях. Якщо про інші захоплені міста, як то Маріуполь чи Кремінна
          можна сказати, що вони сильно поруйновані, то Бахмута більше не існує
          взагалі: це історичне місто окупанти перетворили на купу цегли.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>грудень</TimelineSubtitle>
          <p>
            Підрозділи РФ поступово прогризали собі шлях до Бахмута з північного
            сходу та південного сходу і на цей момент перебували на межі
            Яковлівки, Бахмутського та Опитного. Кожне село займало у них тижні
            боїв із ЗСУ та, як правило, перетворювалося на руїни. В середині
            грудня російські війська почали атакувати міську забудову Бахмута.
          </p>

          <TimelineSubtitle>кінець січня</TimelineSubtitle>
          <p>
            РФ після тривалих боїв захоплює містечко Соледар неподалік від
            Бахмута. Паралельно просувається з півдня на Кліщіївку та
            намагається взяти Бахмут у півколо.
          </p>
          <TimelineVideo id={'jdIM3pwC8aU'} />

          <TimelineSubtitle>кінець лютого</TimelineSubtitle>
          <p>
            З півночі захоплені Берхівка, Красна Гора, Ягідне, і Бахмут
            опиняється в напів оточенні. Паралельно агресор просувається
            всередині міста, штурмуючи кожен будинок.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/01000000-0aff-0242-f344-08db18a3d1c0_w1000.jpg'
              }
            />
            <span>Бахмут. Центр. 25 лютого 2023-го</span>
          </TimelineImage>

          <TimelineSubtitle>березень</TimelineSubtitle>
          <p>
            Російські підрозділи на цей момент пройшли близько половини міської
            забудови та ще більше звузили кліщі. Бахмут, попри таку ситуацію,
            мав сполучення із західного краю: на Часів Яр, Костянтинівку та
            певний час на Слов’янськ (потім ця дорога була перерізана).
          </p>
          <TimelineVideo id={'RB9NaAXGgz0'} />

          <TimelineSubtitle>квітень-травень</TimelineSubtitle>
          <p>
            Сили РФ зосередилися на міській забудові та «дотискали» Бахмут до
            західного краю. Проте, на 100% зайняти місто їм так і не вдалося:
            почалась нова хвиля наступу України.
          </p>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
